import { html, render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import { langId } from "@escapio/shared/l10n/lang-id";
import { pageType } from "@escapio/portal/state/pageType";
import {
	getVersion,
	unwatch as unwatchScreenSize,
	watch as watchScreenSize,
} from "@escapio/portal/dom/screen";

const buildOptions = () =>
	[
		{
			action: "Flug & Hotel",
			url:
				langId === "de"
					? "https://www.tui.com/pauschalreisen/?coopid=AFF_TUI_ESCAPIO&utm_campaign=hotelonly&utm_content=10121&utm_medium=metasearch&utm_source=escapio"
					: buildKayakUrl("/packages", "Paket"),
			icons: ["fa-plane", "fa-bed"],
			label: translate("travel_types_flight_and_hotel"),
		},
		langId === "de"
			? {
					action: "Rundreisen",
					url: "https://www.exoticca.com/de?utm_reseller=escapio&utm_source=escapio&utm_medium=whitelabel&utm_campaign=de_de_escapio_dis_genreic_m202503",
					icons: ["fa-globe"],
					label: translate("travel_types_tour"),
				}
			: {
					action: "Nur Flug",
					url: buildKayakUrl("/flights", "Flug"),
					icons: ["fa-plane"],
					label: translate("travel_types_only_flight"),
				},
		langId === "de"
			? {
					action: "Mietwagen",
					url: "https://www.sunnycars.de/?ak=736993",
					icons: ["fa-car"],
					label: translate("travel_types_rental_car"),
				}
			: null,
	].filter(Boolean);

const buildKayakUrl = (urlParam, trackingParam) => {
	const url = {
		de: new URL("https://www.kayak.de/in"),
		en: new URL("https://www.kayak.com/in"),
		es: new URL("https://www.kayak.es/in"),
		da: new URL("https://www.kayak.dk/in"),
	}[langId];

	url.searchParams.append("a", "kan_69557");
	url.searchParams.append("url", urlParam);
	url.searchParams.append(
		"p",
		`${trackingParam}|${pageType}|${getVersion()}|${langId}`,
	);

	return url;
};

customElements.define(
	"esc-travel-type-selector",
	class extends HTMLElement {
		connectedCallback() {
			this.render();
			watchScreenSize(this, this.render.bind(this));
		}

		disconnectedCallback() {
			unwatchScreenSize(this);
		}

		render() {
			const template = html`<div
					class="travel-type__option travel-type__option--active"
				>
					<span class="travel-type__icons"><i class="fa fa-bed"></i></span>
					${translate("travel_types_only_hotel")}
				</div>
				${buildOptions().map(
					({ action, url, icons, label }) =>
						html`<esc-click-tracker
							category="Reisedaten"
							action=${action}
							label=${this.eventLabel}
						>
							<a
								href=${url}
								target="_blank"
								rel="nofollow noopener"
								class="travel-type__option"
							>
								<span class="travel-type__icons">
									${icons.map(icon => html`<i class="fa ${icon}"></i>`)}
								</span>
								${label}
							</a>
						</esc-click-tracker>`,
				)}`;
			render(template, this, { host: this });
		}

		get eventLabel() {
			return `${pageType}${this.eventLabelSuffix}`;
		}

		get eventLabelSuffix() {
			return this.getAttribute("event-label-suffix")
				? `|${this.getAttribute("event-label-suffix")}`
				: "";
		}
	},
);
